import { render } from "./KonvaSegmentationPolygon.vue?vue&type=template&id=3cb6fb34"
import script from "./KonvaSegmentationPolygon.vue?vue&type=script&lang=js"
export * from "./KonvaSegmentationPolygon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__